import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from 'rxjs/operators';
import { PoliticaPlanteamientoPolitica } from '../_models/politica-planteamiento-politica';
import { AppSettings } from "./../../proyect.conf";
import { AutenticacionService } from "./autenticacion.service";

@Injectable({
  providedIn: "root",
})
export class PoliticasPlanteamientosPoliticasService {
  private rutServicioCanal =
    AppSettings.rutServiciosPOLITICA + "/api/politicasPlanteamientosPoliticas";

  constructor(
    private httpClient: HttpClient,
    private autServicio: AutenticacionService
  ) {}

  listado() {
    return this.httpClient
      .get(this.rutServicioCanal)
      .pipe(map((res) => res as PoliticaPlanteamientoPolitica[]));
  }

  listadoHabilitados() {
    return this.httpClient
      .get(this.rutServicioCanal + "/enabled")
      .pipe(map((res) => res as PoliticaPlanteamientoPolitica[]));
  }

  listadoPorPoliticaHabilitados(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicioCanal + "/politica/" + idPolitica + "/enabled")
      .pipe(map((res) => res as PoliticaPlanteamientoPolitica[]));
  }

  listadoPorPolitica(idPolitica: string) {
    return this.httpClient
      .get(this.rutServicioCanal + "/politica/" + idPolitica)
      .pipe(map((res) => res as PoliticaPlanteamientoPolitica[]));
  }

  listadoPorOperacionHabilitados(idOperacion: string) {
    return this.httpClient
      .get(this.rutServicioCanal + "/operacion/" + idOperacion + "/enabled")
      .pipe(map((res) => res as PoliticaPlanteamientoPolitica[]));
  }

  listadoPorCondicionalHabilitados(idCondicional: string) {
    return this.httpClient
      .get(this.rutServicioCanal + "/condicional/" + idCondicional + "/enabled")
      .pipe(map((res) => res as PoliticaPlanteamientoPolitica[]));
  }

  obtenerPorId(id: string) {
    return this.httpClient
      .get(this.rutServicioCanal + "/" + id)
      .pipe(map((res) => res as PoliticaPlanteamientoPolitica));
  }

  crear(regCrear: PoliticaPlanteamientoPolitica) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .post(this.rutServicioCanal, regCrear)
      .pipe(map((res) => res as PoliticaPlanteamientoPolitica));
  }

  actualizar(regActualizar: PoliticaPlanteamientoPolitica) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient
      .put(this.rutServicioCanal, regActualizar)
      .pipe(map((res) => res as PoliticaPlanteamientoPolitica));
  }

  bulk(registros: PoliticaPlanteamientoPolitica[]) {
    registros.map( ( s: PoliticaPlanteamientoPolitica ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httpClient
      .post(this.rutServicioCanal + '/bulk', registros)
      .pipe(map((res) => res as PoliticaPlanteamientoPolitica[]));
  }
}
